(async () => {

const FREEBIE_PRODUCT_TYPE="Freebie";

async function protect(){

const cart=await fetch('/cart.js').then(r=>r.json());

let updates={};

let seen={};

cart.items.forEach(item=>{

if(item.product_type!==FREEBIE_PRODUCT_TYPE)
return;

if(seen[item.variant_id]){

updates[item.key]=0;

return;

}

seen[item.variant_id]=true;

if(item.quantity>1){

updates[item.key]=1;

}

});

if(Object.keys(updates).length){

await fetch('/cart/update.js',{

method:'POST',

headers:{
'Content-Type':'application/json'
},

body:JSON.stringify({
updates:updates
})

});

location.reload();

}

}

document.addEventListener("DOMContentLoaded",protect);

})();